<template>
	<div>
		<div class="tops">
			<div>欢迎进入甘肃建投专业人员继续教育平台</div>
		</div>
		<div class="content">
			<div class="left">
				<!-- <div class="tit">{{coursedata.eduCourse.title}}</div> -->
				<div class="catalogue"><span>课程目录</span></div>
				<div class="list">
					<div class="item" v-for="(item,index) in courslist" :key="index" ref="listItem"
						@click="Playback(item)">
						<div v-if="item.id === parseInt(it.duration_id)" style="color:#0BAE25;width: 73%;">
							{{item.title}}
						</div>
						<div v-else>{{item.title}}</div>
						<div class="being" v-if="item.id===parseInt(it.duration_id)"><i
								class="el-icon-video-play"></i>正在播放
						</div>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="rig-tit">
					<div>{{it.titles}}</div>
					<!-- <div>总学时：{{coursedata.siteCredits}}学时&emsp;您已学习：{{coursedata.credits}}学时</div> -->
					<div @click="back()"><i class="el-icon-switch-button"></i>离开学习</div>
				</div>
				<div class="rig-video">
					<video ref="videoPlay" width="100%" height="760" :src="cdnurl+coursedata.video_url"
						controlslist="nodownload noremoteplayback" controls @ended='ended()' autoplay>
					</video>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Hls from "hls.js";
	export default {
		data() {
			return {
				coursedata: {
					video_url: '',
					is_check_face: '',
					siteCredits: ''
				},
				cdnurl: this.$cdn,
				courslist: [],
				Tips: true,
				it: {
					titles: '',
					duration_id: ''
				},
				//是否播放完成
				configs: [],
			};
		},
		created() {

		},
		mounted() {
			this.configs = JSON.parse(sessionStorage.getItem('configs'))
			this.it = this.$route.query
			this.getcourse()
		},
		methods: {

			//获取课程详情
			getcourse() {
				this.$http({
						method: 'GET',
						url: '/edu/durationdetailnew1?course_id=' + this.it.course_id + '&directory_id=' + this.it
							.directory_id +
							'&duration_id=' + this.it.duration_id,
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						}
					})
					.then(response => {
						if (response.code == 1) {
							this.coursedata = response.data
							this.courslist = response.data.eduDuration.data
							// this.courslist.forEach(res => {
							// 	res.userDuration = {};
							// 	if (this.coursedata.userDuration.hasOwnProperty(res.id)) {
							// 		res.userDuration = this.coursedata.userDuration[res.id];
							// 	}
							// })
							//判断视频是否为视频流
							const videoUrl = response.data.video_url
							var urlArr = videoUrl.split('.');
							if (urlArr[urlArr.length - 1] === 'm3u8') {
								this.$nextTick(() => {
									const video = this.$refs.videoPlay;
									const hls = new Hls();
									hls.loadSource(videoUrl);
									hls.attachMedia(video);
								});
							}
							for (var s = 0; s < this.courslist.length; s++) {
								// console.log(this.courslist[1])
								if (this.it.duration_id == this.courslist[s].id) {
									let syy = s
									// console.log(syy)
									this.$nextTick(() => {

										const targetItem = this.$refs.listItem[syy];
										if (targetItem) {
											targetItem.scrollIntoView();
										}
									});
								}
							}
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			Playback(it) {
				// console.log(it)
				this.$router.push({
					path: "/videos",
					query: {
						course_id: this.it.course_id,
						directory_id: this.it.directory_id,
						duration_id: it.id,
						titles: it.title
					}
				})
				this.getcourse()
				location.reload();
			},
			//离开学习
			back() {
				this.$router.push({
					path: "/course",
				})
			},
		},
	}
</script>

<style scoped>
	.tops {
		width: 1890px;
		height: 43px;
		line-height: 43px;
		background: #E9E9E9;
	}

	.tops div {
		margin-left: 150px;
	}

	.Tips {
		width: 1890px;
		height: 67px;
		line-height: 67px;
		background: #FFF1F0;
		border-radius: 8px;
		border: 1px solid #FFCCC7;
	}

	.Tips div:nth-child(1) {
		color: #F40000;
		margin-left: 25px;
		float: left;
	}

	.Tips div:nth-child(3) {
		margin-right: 25px;
		float: right;
	}

	.nostudy {
		color: #636363 !important;
	}

	.Tips div:nth-child(2) {
		float: left;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		margin-left: 15px;
		color: rgba(0, 0, 0, 0.88);
	}

	.content {
		width: 1910px;
		height: 93vh;
		background-image: url('../../assets/videobj.jpg');
	}

	.content .left {
		float: left;
		width: 25%;
		height: 97.5%;
		margin-left: 0.5%;
		margin-top: 0.5%;
		background: #FFFFFF;
	}

	.content .left .tit {
		width: 96%;
		padding-top: 20px;
		min-height: 85px;
		line-height: 34px;
		background: #FFFFFF;
		font-size: 20px;
		padding-left: 20px;
		font-weight: bold;
		color: #0762B3;
	}

	.content .left .catalogue {
		width: 100%;
		height: 74px;
		line-height: 74px;
		background: #0762B3;
	}

	.content .left .catalogue span {
		font-size: 22px;
		font-weight: bold;
		padding-left: 51px;
		color: #FFFFFF;
	}

	.content .left .list {
		width: 100%;
		height: 90%;
		margin-top: 10px;
		overflow-y: scroll;
	}

	/*滚动条样式*/

	.content .left .list::-webkit-scrollbar {
		/*滚动条整体样式*/

		width: 2px;
		/*高宽分别对应横竖滚动条的尺寸*/

		height: 4px;

	}

	.content .left .list::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/

		border-radius: 5px;

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		background: rgba(0, 0, 0, 0.2);

	}

	.content .left .list::-webkit-scrollbar-track {
		/*滚动条里面轨道*/

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		border-radius: 0;

		background: rgba(0, 0, 0, 0.1);

	}

	.content .left .list .item {
		min-height: 20px;
		line-height: 20px;
		width: 95%;
		margin: 20px auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}

	.content .left .list :hover div {
		color: #0BAE25;
	}

	.content .left .list .item div:nth-child(1) {
		min-height: 33px;
		width: 100%;
		float: left;
	}

	.content .left .list .item .being .el-icon-video-play {
		margin-right: 6px;
	}

	.content .left .list .item .being {
		width: 100px !important;
		height: 30px;
		background: #0BAE25;
		color: #fff !important;
		border-radius: 17px;
		font-size: 14px;
		line-height: 30px;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center !important;
	}

	.content .left .list .item div:nth-child(2) {
		min-height: 30px;
		width: 27%;
		float: right;
		color: #0BAE25;
		text-align: right;
	}

	.content .right {
		float: right;
		width: 73.4%;
		height: 97.5%;
		margin-right: 0.5%;
		margin-top: 0.5%;
		background: #FFFFFF;
	}

	.content .right .rig-tit {
		height: 68px;
		line-height: 68px;
	}

	.content .right .rig-tit div:nth-child(1) {
		min-width: 120px;
		font-size: 20px;
		font-weight: 400;
		color: #131212;
		float: left;
		margin-left: 31px;
	}

	.el-icon-switch-button {
		margin-right: 5px;
	}

	/* .content .right .rig-tit div:nth-child(2) {
		font-size: 16px;
		font-weight: 400;
		float: left;
		color: #000000;
		margin-left: 150px;
	} */

	.content .right .rig-tit div:nth-child(2) {
		font-size: 16px;
		font-weight: 400;
		float: right;
		color: #0762B3;
		margin-right: 20px;
		cursor: pointer;
	}

	.content .right .rig-video {
		width: 98%;
		margin: 0 auto;
		height: 760px;
		background: #000000;
	}

	video {
		border: 0;
		object-fit: fill;
	}

	/* video::-webkit-media-controls-fullscreen-button {
		display: none !important;
	}

	video:focus {
		outline: -webkit-focus-ring-color auto 0px;
	}

	video::-webkit-media-controls-timeline {
		display: none;
	}

	video::-webkit-media-controls-volume-slider {
		display: none;
	} */
</style>